import { NavLink as MantineNavLink } from '@mantine/core';
import { NavLink as RouterNavLink } from 'react-router-dom';

// for typing with Router polymorphic
export const SharedLink = MantineNavLink<typeof RouterNavLink>;
